import { z } from 'zod'

/**
 * Composed by the following:
 *
 * @link https://open.shopee.com/documents/v2/v2.logistics.get_channel_list?module=95&type=1
 * @see LOGISTICS_ATTRIBUTES_V2_MAPPING
 */
export const ShopeeLogisticsProvider = z.object({
    logistic_name: z.string(),
    logistic_id: z.number(),
    logistics_description: z.string().optional(),
    weight_limits: z
        .object({
            item_min_weight: z.number(),
            item_max_weight: z.number(),
        })
        .optional(),
    volume_limit: z
        .object({
            item_min_volume: z.number(),
            item_max_volume: z.number(),
        })
        .optional(),
    has_cod: z.boolean().optional(),
    item_max_dimension: z
        .object({
            width: z.number(),
            length: z.number(),
            unit: z.string(),
            height: z.number(),
        })
        .optional(),
    size_list: z
        .object({
            size_id: z.string(),
            name: z.string(),
            default_price: z.number(),
        })
        .array()
        .default([]),
    fee_type: z
        .enum(['SIZE_INPUT', 'SIZE_SELECTION', 'FIXED_DEFAULT_PRICE', 'CUSTOM_PRICE'])
        .optional(),
    is_free: z.boolean().default(false),
    shipping_fee: z.number().optional(),
    force_enabled: z.boolean().default(false),
    mask_channel_id: z.number().default(0),
    block_seller_cover_shipping_fee: z.boolean().default(false),
    support_cross_border: z.boolean().default(false),
    enabled: z.boolean().default(false),
})
export type ShopeeLogisticsProvider = z.infer<typeof ShopeeLogisticsProvider>
export type ShopeeLogisticsProviderInput = z.input<typeof ShopeeLogisticsProvider>
